module.exports = __webpack_public_path__ + "static/features-blueprint-a5e6421fc914f0b0296d0b22ffc4b91f.png";